// Shared toggle behavior for the left-rail panels (BUILD, FEED, etc.).
// Opens this panel and closes any other rail panel — mutually exclusive
// so the canvas stays uncluttered.

export function makeToggleable(root, toggleBtn) {
  root.dataset.railPanel = '1'
  toggleBtn.disabled = false
  toggleBtn.addEventListener('click', () => {
    const willOpen = !root.classList.contains('open')
    document.querySelectorAll('[data-rail-panel]').forEach((p) => {
      p.classList.remove('open')
    })
    if (willOpen) root.classList.add('open')
  })
}

// Modal variant — makes a rail panel pop up as a CENTERED CARD over a dim,
// full-screen backdrop (matching the REGISTRY / ADVENTURE modals) instead of
// sliding in docked on the left rail. The panel keeps its existing markup:
// we wrap whatever content it rendered into a scrollable card, so callers only
// swap makeToggleable → makeModalToggleable with no template changes.
//
// Behavior: clicking the rail button toggles it (closing any other panel);
// clicking the dim backdrop closes it; a × in the card's corner closes it
// (skipped if the panel already ships its own close control, e.g. CLOUD).
export function makeModalToggleable(root, toggleBtn) {
  root.dataset.railPanel = '1'
  root.classList.add('hud__modal')

  // Wrap the panel's content once: card → scroll → (original children). The
  // close button lives on the card (outside the scroll area) so it stays put
  // while long panels scroll. querySelector is recursive, so the panel's own
  // sub-host lookups (data-rows, data-owned, …) keep working after the move.
  if (!root.querySelector('.hud__modal-card')) {
    const card = document.createElement('div')
    card.className = 'hud__modal-card'
    const scroll = document.createElement('div')
    scroll.className = 'hud__modal-scroll'
    while (root.firstChild) scroll.appendChild(root.firstChild)
    card.appendChild(scroll)
    // Only add a generic close if the panel doesn't already have its own.
    if (!scroll.querySelector('[data-cloud-close], .hud__cloud-close')) {
      const close = document.createElement('button')
      close.className = 'hud__modal-close'
      close.setAttribute('aria-label', 'Close')
      close.textContent = '×'
      close.addEventListener('click', () => root.classList.remove('open'))
      card.appendChild(close)
    }
    root.appendChild(card)
  }

  // toggleBtn is optional — panels opened another way (e.g. Settings, opened
  // from the Registry header gear) pass null and get just the modal behavior.
  if (toggleBtn) {
    toggleBtn.disabled = false
    toggleBtn.addEventListener('click', () => {
      const willOpen = !root.classList.contains('open')
      document.querySelectorAll('[data-rail-panel]').forEach((p) => {
        p.classList.remove('open')
      })
      if (willOpen) root.classList.add('open')
    })
  }

  // Click on the dim backdrop (outside the card) → close.
  root.addEventListener('click', (e) => {
    if (e.target === root) root.classList.remove('open')
  })
}
